<template>
  <div class="prescriptionTemplate" v-loading="loading">
    <div class="warp">
      <div class="warp-left">
        <div>
          <el-input placeholder="请输入内容" prefix-icon="el-icon-search" @input="searchTemplate"
            v-model="recipeTemplateTypeName" clearable>
          </el-input>
        </div>
        <div class="list-warp">
          <div class="top-nav" v-if="!recipeTemplateTypeName">
            <div v-for="item in tabList" :class="activeName == item.type ? 'active' : ''" @click="handleSelect(item.type)">{{ item.name }}</div>
          </div>
          <div class="numBox align-i-c just-c color6671 borderB_EBE" style="height: 32px;"
            v-if="recipeTemplateTypeName">搜索到 <span class="ml4 mr4 color1F23">{{ recipeList.length }}</span>
            条信息
          </div>
          <div class="type-name">
            <div class="type-warp" v-if="!recipeTemplateTypeName">
              <div :class="activeTypeId == item.recipeTemplateTypeId ? 'active' : ''" v-for="item in typeList"
                :key="item.recipeTemplateTypeId" class="name" @click="changeActiveType(item.recipeTemplateTypeId)">{{
                  item.recipeTemplateTypeName }}
                <img class="icon-img" :src="imgArr.file" />
              </div>

            </div>
            <div class="name-warp pr" v-if="recipeList.length == 0">
              <el-empty :image-size="1" description="暂无处方信息">
              </el-empty>

            </div>
            <div class="name-warp" v-if="recipeList.length > 0">
            <!-- <div class="name-warp" v-if="recipeList.length > 0"
              :style="{ 'width': (recipeTemplateTypeName ? '364px' : '182px') }"> -->
              <div :class="activeRecipeId == item.recipeTemplateId ? 'active' : ''" v-for="item in recipeList"
                :key="item.recipeTemplateId" class="name" @click="changeActive(item.recipeTemplateId)"
                @dblclick="dbRecipeTemplate(item.recipeTemplateId)">
                <div class="flex-sh w90 text-overflow">{{ item.recipeTemplateName }}</div>
                <div class="flex-sh size12 color667"><span v-if="recipeTemplateTypeName">{{computeRecipeType(item.recipeType)}}-</span>{{ item.type == '0' ? '中药' : '理疗' }}</div>
                <img class="icon-img" :src="imgArr.note" />
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="warp-right" v-if="recipeInfo == null">
        <div class="width100 height100 display-f  just-c align-i-c">
          暂无处方信息
        </div>
        <!-- <el-empty image="" description="暂无处方信息" ></el-empty> -->

      </div>
      <div class="warp-right" v-if="recipeInfo != null">
        <div class="right-title">{{ recipeInfo.recipeTemplateName }}</div>
        <div class="right-desc">
          <div class="desc-item">
            <div class="item-label">名称</div>
            <div class="item-value">{{ recipeInfo.recipeTemplateName }}</div>
          </div>
          <div class="desc-item">
            <div class="item-label">来源</div>
            <div class="item-value">{{ recipeInfo.origin }}</div>
          </div>
          <div class="desc-item">
            <div class="item-label">功用</div>
            <div class="item-value">{{ recipeInfo.effect }}</div>
          </div>
          <div class="desc-item">
            <div class="item-label">主治</div>
            <div class="item-value">{{ recipeInfo.attending }}</div>
          </div>
          <div class="desc-item">
            <div class="item-label">加减法</div>
            <div class="item-value">{{ recipeInfo.method }}</div>
          </div>
          <div class="desc-item">
            <div class="item-label">建议</div>
            <div class="item-value">{{ recipeInfo.suggestion }}</div>
          </div>
        </div>
        <div class="right-detail">
          <div class="detail-title">处方明细</div>
          <div v-if="recipeInfo.type == 0">
            <div class="drug-warp " >
              <div class="drug-item  display-f flex-col" v-for="item in recipeInfo.recipeTemplateDrugs" :key="item.spuId">
                <div class="display-f just-b">
                  <el-tooltip class="item" effect="dark" :content="item.spuCommonName" placement="top-start">
                    <div class="drug-name pointer lineOne">{{ item.spuCommonName }}</div>
                  </el-tooltip>
                  <div>{{ item.number }}{{ item.unit }}</div>
                </div>
                <div class="size12 color6671">{{ item.handling || '-' }}</div>
              </div>
            </div>
            <div class="recipe-used">
              <span v-if="recipeInfo.recipeMethod">{{ recipeInfo.doseNum }}剂，</span>
              <span v-if="recipeInfo.recipeMethod">{{ recipeInfo.recipeMethod }}</span>
              <span v-if="recipeInfo.doseFrequency">，{{ recipeInfo.doseFrequency }}</span>
              <span v-if="recipeInfo.frequency">，{{ recipeInfo.frequency }}</span>
              <span v-if="recipeInfo.takingDosage">，{{ recipeInfo.takingDosage }}</span>
              <span v-if="recipeInfo.mixingBagNum">，每次{{ recipeInfo.mixingBagNum }}袋</span>
              <span v-if="recipeInfo.creamDosage">，{{ recipeInfo.creamDosage }}</span>
              <span v-if="recipeInfo.pelletizingDosage">，{{ recipeInfo.pelletizingDosage }}</span>
              <span v-if="recipeInfo.bakingPowderDosage">，{{ recipeInfo.bakingPowderDosage }}</span>
              <span v-if="recipeInfo.takingDays">，{{ recipeInfo.takingDays }}</span>
              <span v-if="recipeInfo.recipeMoment">，{{ recipeInfo.recipeMoment }}</span>
              <span v-if="recipeInfo.applicationTime">，{{ recipeInfo.applicationTime }}</span>
              <span v-if="recipeInfo.wrapTime">，{{ recipeInfo.wrapTime }}</span>
              <span v-if="recipeInfo.remark">，{{ recipeInfo.remark }}</span>
            </div>
          </div>
          <div v-if="recipeInfo.type == 1 && recipeInfo.recipeTemplateDrugs" class="phy-list">
            <div class="phy-item" v-for="(phyItem, phyIndex) in recipeInfo.recipeTemplateDrugs">
              <div class="phy-title">项目{{ phyIndex + 1 }}：{{ phyItem.spuCommonName }}</div>
              <div class="phy-acupoint"
                v-if="phyItem.acupointinfoList && phyItem.acupointinfoList.length > 0">{{
                  computeAcupoint(phyIndex) }}</div>
              <div class="phy-desc">
                <div>{{ phyItem.soldNum }}次</div>
                <div class="ml8"
                  v-if="phyItem.executionMode == 20 && phyItem.onlyNum">1次{{
                    phyItem.onlyNum }}组</div>
                <div class="ml8">{{ phyItem.executeDesc }}</div>
              </div>
              <div v-if="phyItem.remark" class="phy-remark">
                <div>理疗备注:{{ phyItem.remark }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-warp">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="userModal" type="primary">使用</el-button>
    </div>
  </div>
</template>

<script>
import { typeList, recipeList, recipeInfo,getType,getRecipeSearch } from "@/api/prescription"; // 处方模板请求
import { Utils } from '@/utils/utils'
import { isNull,dictText  } from "@/utils/validateBase";
import { imgArr } from "@/assets/images/img";
import { isEmptyArray } from "../../../../utils/validateBase";
export default {
  // 定义引入的组件
  components: {},
  props: {},
  data() {
    return {
      imgArr: imgArr,
      loading: false,
      recipeTemplateTypeName: '',
      activeName: '2',
      typeList: [], // 处方类别列表
      recipeList: [], // 处方列表
      activeTypeId: null, // 激活类型id
      activeRecipeId: null, // 激活处方id
      recipeInfo: null, // 激活处方详情
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
      ],
      tabList:[]
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  async created() {
    await this.getType()
    this.getTypeList(0)
  },
  // 页面DOM加载完成
  mounted() {
    document.addEventListener('keyup', this.handleGlobalEnterKey)
  },
  //离开页面时执行
  beforeDestroy () {
    document.removeEventListener('keyup', this.handleGlobalEnterKey)
  },
  destroyed() { },
  computed: {
    computeRecipeType(){
      return function (value) {
        const map = {
          '1':'经方',
          '2':'专用',
          '3':'验方',
        }
        return map[value]
      }
    },
    computeAcupoint() {
      let that = this;
      const SiFenLeft =[
        { label: '四缝1', value: '1-1' },
        { label: '四缝2', value: '1-2' },
        { label: '四缝3', value: '1-3' },
        { label: '四缝4', value: '1-4' },
      ]
      const SiFenRight =[
        { label: '四缝1', value: '2-1' },
        { label: '四缝2', value: '2-2' },
        { label: '四缝3', value: '2-3' },
        { label: '四缝4', value: '2-4' },
      ]
      return function (phyIndex) {
        let str = ''
        if (!isNull(that.recipeInfo.recipeTemplateDrugs)) {
          let phyItem = that.recipeInfo.recipeTemplateDrugs[phyIndex]
          phyItem.acupointinfoList && phyItem.acupointinfoList.forEach(v => {
            if(v.type == 60){
              let left = ''
              let leftFlag = false
              let right = ''
              let rightFlag = false
              v.typeExtend.forEach(v1=>{
                SiFenLeft.forEach(v2=>{
                  if(v1 == v2.value){
                    leftFlag = true
                    left = left + v2.label + '、'
                  }
                })
                SiFenRight.forEach(v2=>{
                  if(v1 == v2.value){
                    rightFlag = true
                    right = right + v2.label + '、'
                  }
                })
              })
              left =  left.slice(0, -1)
              right = right.slice(0, -1)
              str = str + `【${v.typeExtend.length}】${v.acupointName}(${leftFlag ? '左手：' : ''}${left} ${rightFlag ? '右手：' : ''}${right})、`
            }else if(v.type == 50){
               str = str + `【${v.typeExtend[0]}】${v.acupointName}、`
            }else{
              str = str + `【${dictText(v.type,that.acupointType)}】${v.acupointName}、`
            }
          })
        }
        str = str.slice(0, -1);
        return str
      }
    }
  },
  // 页面方法
  methods: {
    handleGlobalEnterKey (event) {
      if (event.key === 'Enter') {
        this.userModal()
      }
    },
    /**
     * 切换模版类型
     */
    handleSelect(val) {
      this.typeList = [];
      this.recipeList = [];
      this.activeRecipeId = null;
      this.recipeInfo = null;
      this.activeName = val
      if (val == 1) {
        this.getTypeList(null)
      } else {
        this.getTypeList(0)
      }
    },
    /**
     * 获取获取处方类别
     */
    getTypeList(doctorId) {
      this.loading = true
      typeList({ doctorId: doctorId, recipeTemplateTypeName: this.recipeTemplateTypeName, recipeType: this.activeName }).then(res => {
        let { code, rows, total } = res
        if (code == 200) {
          this.typeList = rows;
          if (Utils.gt(total, 0)) {
            this.activeTypeId = rows[0].recipeTemplateTypeId
            this.getRecipeList();
          } else {
            if (!isNull(this.recipeTemplateTypeName)) {
              this.getRecipeList(this.recipeTemplateTypeName);
            } else {
              this.activeTypeId = null;
              this.activeRecipeId = null
              this.recipeList = [];
              // this.getRecipeList();
            }
          }
          this.loading = false;
        }
      })
    },
    /**
     * 获取处方列表
     */
    getRecipeList(search, data, index) {
      this.loading = true
      if (!isNull(search)) {
        this.activeTypeId = null;
        this.activeRecipeId = null
      }
      recipeList({ recipeTemplateTypeId: this.activeTypeId, name: search,recipeType: this.activeName }).then(res => {
        let { code, rows, total } = res
        if (code == 200) {
          this.recipeList = rows;
          if (Utils.gt(total, 0)) {
            if (data != undefined) {
              this.activeRecipeId = data;
              rows.forEach((item, index) => {
                if (item.recipeTemplateId == data) this.defaultActive = String(index + 1);
              })
            } else if (index != undefined) {
              this.defaultActive = index;
              this.activeRecipeId = rows[0].recipeTemplateId;
            } else if (this.activeRecipeId == null) {
              this.activeRecipeId = rows[0].recipeTemplateId;
            }
            this.getRecipeInfo();
          } else {
            this.recipeInfo = null;
            this.loading = false
          }
        }
      })
    },
    /**
     * 获取处方详情
     */
    async getRecipeInfo() {
      if (this.activeRecipeId) {
        let { code, data } = await recipeInfo(this.activeRecipeId);
        if (code == 200) {
          this.recipeInfo = data;
        }
      } else this.recipeInfo = null;
      this.loading = false;
    },
    /**
     * 切换激活类型
     */
    changeActiveType(id) {
      this.activeTypeId = id;
      this.activeRecipeId = null;
      this.defaultActive = '1';
      this.getRecipeList();
    },
    /**
     * 切换激活药方
     */
    changeActive(id) {
      this.activeRecipeId = id;
      this.getRecipeInfo();
    },
    //双击
    async dbRecipeTemplate(id) {
      this.activeRecipeId = id;
      await this.getRecipeInfo();
      this.$emit('recipeInfoBack', this.recipeInfo)
    },
    /**
     * 取消
     */
    cancel() {
      this.$emit('cancel')
    },
    /**
     * 使用模版
     */
    userModal() {
      this.$emit('recipeInfoBack', this.recipeInfo)
    },
    /**
     * 搜索处方模版
     */
    searchTemplate: _.debounce(function () {
      if (!isNull(this.recipeTemplateTypeName)) {
        this.typeList = [];
        // this.getRecipeList(this.recipeTemplateTypeName);
        getRecipeSearch({matchKey:this.recipeTemplateTypeName}).then(res=>{
          if(res.code==200){
            this.recipeList = res.data
            if(!isNull(res.data) && !isEmptyArray(res.data)){
              this.activeRecipeId = res.data[0].recipeTemplateId
              this.getRecipeInfo();
            }
          }
        })
      } else {
        this.handleSelect(1);
      }
    }, 500),
    async getType(){
      let { code, data } = await getType();
      if(code == 200){
        this.tabList = data;
        this.activeName = '2'
      }else{
        this.tabList = []
        this.activeName = ''
      }
    }
  },
}
</script>
<style lang="less" scoped>
.prescriptionTemplate {
  height: 520px;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;

  .warp {
    display: flex;
    height: 100%;
    overflow: auto;

    .warp-left {
      box-sizing: border-box;
      width: 380px;
      height: 100%;
      // border-right: 1px solid #E1E1E1;
      display: flex;
      flex-direction: column;

      .list-warp {
        box-sizing: border-box;
        background: #FAFBFC;
        flex: 1;
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        overflow: auto;
        border: 1px solid #D3D3D5;

        background: #F7F8F9;

        .top-nav {
          box-sizing: border-box;
          padding-top: 8px;
          padding-left: 16px;
          display: flex;
          color: #666;
          font-size: 14px;


          &>div {
            margin-right: 30px;
            cursor: pointer;
          }

          .active {
            color: #347EFF;
            position: relative;

            &::after {
              position: absolute;
              content: '';
              display: block;
              width: 48px;
              bottom: -10px;
              left: 50%;
              border-bottom: 2px solid #347EFF;
              transform: translateX(-50%);
            }
          }
        }

        .borderB_EBE {
          border-bottom: 1px solid #EBEAEE;
        }

        .numBox {
          display: flex;
        }


        .type-name {
          box-sizing: border-box;
          // margin-top: 10px;
          display: flex;
          color: #333;
          font-size: 14px;
          flex: 1;
          overflow: auto;
          margin-top: 10px;
          border-top: 1px solid #D3D3D5;

          .active {
            background: #E0EBFF;
          }

          .type-warp {
            box-sizing: border-box;
            height: 100%;
            overflow-y: auto;
            width: 182px;
            flex-shrink: 0;
            border-right: 1px solid #D3D3D5;

            & div {
              margin-top: 10px;
              padding: 6px;
              position: relative;
              padding-left: 38px;

              .icon-img {
                position: absolute;
                top: 3px;
                left: 12px;
                width: 18px;
                height: 18px;
              }
            }
          }

          .name-warp {
            width: 100%;
            box-sizing: border-box;
            height: 100%;
            overflow-y: auto;

            .name {
              margin-top: 10px;
              padding: 6px;
              padding-left: 40px;
              position: relative;
              display: flex;
              justify-content: space-between;

              .icon-img {
                position: absolute;
                top: 3px;
                left: 12px;
                width: 18px;
                height: 18px;
              }
            }
          }
        }
      }
    }

    .warp-right {
      flex: 1;
      margin-left: 16px;
      overflow: auto;

      .right-title {
        color: #1F2329;
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        background: #F0F1F3;
        padding: 8px 12px;
        border: 1px solid #D3D3D5;
        border-bottom: none;
      }

      .border-none {
        border-bottom: none !important;
      }

      .right-desc {
        // margin-top: 20px;
        border-left: 1px solid #D3D3D5;
        border-right: 1px solid #D3D3D5;
        border-top: 1px solid #D3D3D5;

        .desc-item {
          display: flex;
          line-height: 34px;
          flex: 1;
          border-bottom: 1px solid #D3D3D5;
          background: #F7F8F9;

          .item-label {
            box-sizing: border-box;
            padding-left: 14px;
            width: 80px;
            border-right: 1px solid #D3D3D5;
            color: #667182;
            font-size: 14px;
            flex-shrink: 0;
          }

          .item-value {
            padding-left: 14px;
          }
        }
      }

      .right-detail {
        margin-top: 20px;
        border: 1px solid #D3D3D5;

        .detail-title {
          color: #1F2329;
          font-size: 14px;
          font-weight: 500;
          text-align: left;
          background: #F0F1F3;
          padding: 8px 12px;
          border-bottom: 1px solid #D3D3D5;

        }

        .drug-warp {
          display: flex;
          flex-wrap: wrap;
          background: #F9F9FA;

          .drug-item {
            box-sizing: border-box;
            height: 57px;
            width: 25%;
            padding: 10px;

            border-right: 1px solid #D3D3D5;
            border-bottom: 1px solid #D3D3D5;

            .drug-name {
              width: 94px;
              color: #1F2329;
              font-size: 14px;
              font-weight: 500;
              margin-bottom: 8px;
            }
          }
        }
        .recipe-used{
          line-height: 37px;
          background: #F7F8F9;
          padding-left: 10px;
        }
        .phy-list {
          .phy-item {
            border-bottom: 1px solid #D3D3D5;
            &:last-child{
              border-bottom: none;
            }
            .phy-title {
              height: 40px;
              line-height: 40px;
              padding-left: 12px;
              color: #000;
              font-size: 14px;
              font-weight: 500;
              border-bottom: 1px dashed #D3D3D5;
              box-sizing: border-box;
            }

            .phy-acupoint {
              min-height: 40px;
              line-height: 40px;
              padding-left: 12px;
              color: #000;
              font-size: 14px;
              font-weight: 400;
              border-bottom: 1px dashed #D3D3D5;
              box-sizing: border-box;
            }

            .phy-desc {
              display: flex;
              align-items: center;
              height: 40px;
              padding-left: 12px;
              color: #000;
              font-size: 14px;
              font-weight: 400;
              box-sizing: border-box;
            }
          }

        }
      }
    }
  }

  .btn-warp {
    margin-top: 14px;
    text-align: right;
  }

}

.phy-remark {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: 12px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  border-top: 1px dashed #D3D3D5;
}
</style>